export default __webpack_public_path__ + "static/media/5.29b4bf19.svg";